module.exports = __webpack_public_path__ + "img/2022.c74174ed.png";